import { TextContent } from '@/components';
import React from 'react';

/**
 * Props for the ScoreHistoryCardTitle component.
 */
interface ScoreHistoryCardTitleProps {
  /** Whether the card is in a loading state; renders a skeleton placeholder when true. */
  isLoading?: boolean;
  /** Text to display as the card title. */
  title: string;
}

/**
 * Renders the section title for ScoreHistoryCard.
 * Delegates to TextContent and handles the loading skeleton via the `isLoading` prop.
 */
export const ScoreHistoryCardTitle: React.FC<ScoreHistoryCardTitleProps> = ({
  isLoading = false,
  title,
}) => (
  <TextContent
    isLoading={isLoading}
    label={title}
    level={2}
    loadingClassName="h-[1.5rem] w-1/3"
    type="headline"
    variant="sectionSubTitle"
  />
);

ScoreHistoryCardTitle.displayName = 'ScoreHistoryCardTitle';

export default ScoreHistoryCardTitle;
